import { Component, OnInit, TemplateRef, ChangeDetectorRef, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MatDialog } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { DatePipe } from '@angular/common'
import { Observable, Subscription } from 'rxjs'; import {
  ChartComponent, ApexAxisChartSeries, ApexChart, ApexXAxis, ApexDataLabels,
  ApexTooltip, ApexStroke, ApexNonAxisChartSeries, ApexResponsive, ApexFill, ApexMarkers
} from "ng-apexcharts";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { SelectFormIconComponent } from 'src/app/middleware/common/selectFormIcon/selectFormIcon.component';
import { MatRadioChange } from '@angular/material/radio';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { map, startWith } from 'rxjs/operators';
import { FormsService } from '../../eSignature/services/forms.service';
import { SettingService } from '../../settings/services/settingService/setting.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { SNFTasklistComponent } from 'src/app/middleware/common/snfTasklist/snfTasklist.component';
import { Task3CComponent } from 'src/app/middleware/shared/common/task3c/task3c.component';
import { CoreService } from '../../core/services/coreService/core.service';
import { CreateProjectsComponent } from 'src/app/middleware/common/createProjects/createProjects.component';
import { FormAuditType, ProjectTempType } from '../../eSignature/services/form.enum';
import { UploadAIDocuments } from 'src/app/middleware/common/uploadAIDocuments/uploadAIDocuments.component';
import { SignaturesDataShowComponent } from 'src/app/middleware/common/signaturesDataShow/signaturesDataShow.component';
import { ConfirmDialogChangeComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog-change/confirm-dialog-change.component';
declare var require: any;
const FileSaver = require('file-saver');

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-health-dashboard',
  templateUrl: './health-dashboard.component.html',
  styleUrls: ['./health-dashboard.component.scss']
})
export class HealthDashboardComponent implements OnInit {

  colors = [
    { color: "#e6194b" }, // Red
    { color: "#3cb44b" }, // Green
    { color: "#ffe119" }, // Yellow
    { color: "#4363d8" }, // Blue
    { color: "#f58231" }, // Orange
    { color: "#911eb4" }, // Purple
    { color: "#46f0f0" }, // Cyan
    { color: "#f032e6" }, // Magenta
    { color: "#bcf60c" }, // Lime
    { color: "#fabebe" }, // Light Pink
    { color: "#008080" }, // Teal
    { color: "#e6beff" }, // Lavender
    { color: "#9a6324" }, // Brown // Cream
    { color: "#800000" }, // Maroon
    { color: "#aaffc3" }, // Mint
    { color: "#808000" }, // Olive // Peach
    { color: "#000075" }, // Navy Blue
    { color: "#808080" }  // Gray
  ];
  col = [
    {
      colname: '#F5D428'
    },
    {
      colname: '#6FC040'
    },
    {
      colname: '#52A7F9'
    },
    {
      colname: '#EF8F1E'
    },
    {
      colname: '#EC5C58'
    },
    {
      colname: '#B36AE2'
    },
  ]
  shortinfo = [

    {
      name: 'Skilled Mix',
      value: '72%',
      increase: 'Skilled Residents: 91',
      icon: '<i class="fa fa-pie-chart" aria-hidden="true"></i>',
      color: '#155dfc',
      info: 'coming soon'
    },
    {
      name: 'Census',
      value: '127',
      increase: '+3',
      icon: '<i class="fa fa-user-o" aria-hidden="true"></i>',
      color: '#155dfc',
      info: 'coming soon'
    },
    {
      name: 'Occupancy Rate',
      value: '94%',
      increase: '+2%',
      icon: '<i class="fa fa-bed" aria-hidden="true"></i>',
      color: '#00a63e',
      info: 'coming soon'
    },
    {
      name: 'Overall Compliance',
      value: '92%',
      increase: '-1%',
      icon: '<i class="fa fa-shield" aria-hidden="true"></i>',
      color: '#9810fa',
      info: 'coming soon'
    },
    {
      name: 'Admissions',
      value: '0',
      // increase: 'last 72 hours',
      icon: '<i class="fa fa-user-plus" aria-hidden="true"></i>',
      color: '#f59e0b'
    },
    {
      name: 'Discharges',
      value: '0',
      // increase: '4 planned + 3 LCD',
      icon: '<i class="fa fa-user-times" aria-hidden="true"></i>',
      color: '#d4183d'
    },
    {
      name: '20th Day Alert',
      value: '7',
      increase: 'Approaching Day 20',
      icon: '<i class="fa fa-calendar-o" aria-hidden="true"></i>',
      color: '#155dfc'
    }
  ]

  selectedTab: string = 'Skilled Mix';

  databaseId: string;
  organizationId: string;
  currentUser: any;
  userId: string = "";
  OfficeIDList: any = [];
  myOfficeID: any;
  responseHolder: any = [] = [];
  adtTrackingAdmission: any = [] = [];
  roleIdList: any;
  stageProcessList: any = [] = [];
  adtTrackingtabs: any = [] = [];
  initialized = false;
  private firstLoad = true;
  openDocumentViewers: boolean = false;
  selectedprocessStageID: number = 0;
  addQuickLinkForm: FormGroup;
  currentImportantFavoriteElement: any;
  // Notes  //
  PersonalChecked: boolean = true;
  GlobalChecked: boolean = false;
  PortalChecked: boolean = false;
  addNotesForm: FormGroup;
  selectedColor: string = "";
  showColorDrp: boolean = true;
  // number of items visible
  visibleCount = 3;
  showAll = false;
  orgModuleNameCore: string = "";
  orgModuleNameContact: string = "";
  orgModuleNameCompany: string = "";

  objectList: any = [] = [];
  timeout = null;
  selectCoreList: any = [];
  showSearchCore: boolean = false;
  attachedToCoreList: any = [] = [];

  formIcon: any;
  name: string;
  emailid: string;
  SendEmailList: any[];
  mobileNo: string;
  addButtonShow: boolean;
  SendMobileList: any[];
  spinner: boolean = false;

  searchName: string = '';
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue: string;
  states = this.objectList;
  isShare: false;
  showAddCore: boolean = false;
  mainModuleName: string = '';
  folderID: number = 0;
  selectedCoreId: number = 0;
  sendFrom: string = "SendTasklist";
  TaskListName: string = "";
  @ViewChild('SendTaskListURL', { static: true }) SendTaskListURLTemplate: TemplateRef<any>;
  taskTemplateAfterAddingCore: any;
  checkedByDefaultEmail = true;
  checkedByDefaultCore = false;
  AttachChecked: boolean = false;
  AssigneeChecked: any;
  NotifyChecked: any;
  showEmail: boolean;
  SendEmailLater: boolean = false;
  isOnlyTaskView = true;
  taskTemplateID: any;
  taskListFolderID: any;
  showMobile: boolean;
  ButtonForFolder: boolean;
  ButtonForUploadImage: boolean;
  relationList: any = [] = [];
  sendButton: boolean;
  sendForSign: any;
  currentTemplateId: any;
  Module: string = "";
  selectedCoreEmailID: string = '';
  AddTaskListEmailResult: any;
  CorefolderID: number = 0;
  menuModulesList: any = [] = [];
  contactsSelectedList: any = [];
  attachedToContactList: any = [];
  ContactfolderID: number = 0;
  showAddContact: boolean = false;
  clickEventsubscriptionCore: Subscription;

  constructor(private formBuilder: FormBuilder, private router: Router, private dialog: MatDialog, private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef, private reusableClass: ReusableClasses, private encryptionAlgo: EncryptionService,
    private formsService: FormsService, public datepipe: DatePipe, private statusConstant: StatusConstant,
    private toastr: ToastrService, private taskService: SettingService,
    private loaderService: LoaderService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices = [];
    offices = JSON.parse(sessionStorage.getItem('officeList'));
    if (offices.length > 0) {
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID)
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }

  }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var core = [];
    var contact = [];
    core = menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (core.length > 0) {
      this.orgModuleNameCore = core[0].orgModuleName;
    } else {
      this.orgModuleNameCore = "";
    }

    contact = menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (contact.length > 0) {
      this.orgModuleNameContact = contact[0].orgModuleName;
    } else {
      this.orgModuleNameContact = "";
    }

    this.clickEventsubscriptionCore = this._dataSharingService.getSaveUserForCore().subscribe(() => {
      this.getDashboardProcessStages();
      this.getSNFDashboardCores(this.selectedprocessStageID);
    });

    this.addQuickLinkForm = this.formBuilder.group({
      quickLink: new FormControl("#f5d428"),
    });
    setTimeout(() => this.initialized = true); // after first change detection
    this.getDashboardProcessStages();
    this.DashboardFavoriteItems();
    this.getSNFDashboardCores(this.selectedprocessStageID);
    this.getInboxProjects(this.pageModelData);
    this.getSentProjects(this.pageModelData);
    this.getDraftedProjects(this.pageModelData);
  }

  ngOnDestroy() {
    if (this.clickEventsubscriptionCore) {
      this.clickEventsubscriptionCore.unsubscribe();
    }
  }

  getSNFDashboardCores(selectedprocessStageID) {
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });
    var ReqModel = {
      processStatus: selectedprocessStageID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      roleList: this.roleIdList
    };
    this.loaderService.show();
    this.formsService.getSNFDashboardCores(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        this.openFrom = "";
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          if (this.responseHolder.data != null) {
            this.adtTrackingtabs = this.responseHolder.data.stages;
            this.adtTrackingAdmission = this.responseHolder.data.cores;
            if (this.adtTrackingAdmission == null) {
              this.adtTrackingAdmission = [];
            }
            if (this.shortinfo.length > 0 && this.adtTrackingtabs?.length > 0) {
              // find Admissions stage from stages
              const admissionStage = this.adtTrackingtabs.find(
                (s: any) => s.processStageName === 'Admissions'
              );
              const dischargeStage = this.adtTrackingtabs.find(
                (s: any) => s.processStageName === 'Discharges'
              );

              // update Admissions card
              const admissionsItem = this.shortinfo.find(item => item.name === 'Admissions');
              if (admissionsItem && admissionStage) {
                admissionsItem.value = admissionStage.count.toString();
              }

              // update Discharges card
              const dischargesItem = this.shortinfo.find(item => item.name === 'Discharges');
              if (dischargesItem && dischargeStage) {
                dischargesItem.value = dischargeStage.count.toString();
              }
            }
          }

        } else {
          this.adtTrackingAdmission = [];
          this.loaderService.hide();
        }
      } else {
        this.adtTrackingAdmission = [];
        this.loaderService.hide();
      }
    });
  }




  getDashboardProcessStages() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    }
    this.taskService.getDashboardProcessStages(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          this.stageProcessList = response.data;
        } else {
          this.stageProcessList = [];
        }
      } else {
        this.stageProcessList = [];
      }
    });
  }

  isOverwrite: boolean = true;

  //changeProcessStageForCore
  changeProcessStageForCore(currectProcessStageID: 0, selectedProcessStageID: string, coreID: any, item: any) {
    if (Number(selectedProcessStageID) == 0) {
      this.toastr.warning('Please Select Proper Stage Process.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (item.coreProcessStages.length > 0) {
      var checks: any = [] = [];
      checks = item.coreProcessStages.filter(x => x.processStageID == Number(selectedProcessStageID));
      if (checks.length > 0) {
        this.changeStage(selectedProcessStageID, coreID);
        return;
      }
    }

    var ReqModel = {
      processStageID: Number(selectedProcessStageID),
      isOverwrite: this.isOverwrite,
      coreID: Number(coreID),
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.formsService.changeProcessStageForCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.getSNFDashboardCores(this.selectedprocessStageID);
          this.toastr.success('Process stage status updated successfully.', '', {
            timeOut: 3000,
          });

        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  changeStage(selectedProcessStageID, coreID) {
    const message = `Are you sure you want to move to this stage? This person was already in this stage earlier, and moving again will regenerate all documents and forms.`;
    const title = `Confirm move`;
    const confirm = `Move`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogChangeComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var isOverwrite = false;
          if (dialogResult == "WithoutFolder") {
            isOverwrite = false;
          }
          if (dialogResult == "CreateNewFolder") {
            isOverwrite = true;
          }
          var ReqModel = {
            processStageID: Number(selectedProcessStageID),
            coreID: Number(coreID),
            isOverwrite: isOverwrite,
            userId: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            officeID: this.myOfficeID,
          }
          this.loaderService.show();
          this.formsService.changeProcessStageForCore(ReqModel).subscribe(response => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                this.loaderService.hide();
                this.getSNFDashboardCores(this.selectedprocessStageID);
                this.toastr.success('Process stage status updated successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
        this.getSNFDashboardCores(this.selectedprocessStageID);
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  onTabChanged(event: MatTabChangeEvent) {
    if (this.firstLoad) {
      this.firstLoad = false; // ignore the first automatic event
      return;
    }
    if (event.index >= 0 && event.index < this.adtTrackingtabs.length) {
      var selectedTab = this.adtTrackingtabs[event.index];
      this.adtTrackingAdmission = [];
      this.selectedprocessStageID = selectedTab.processStageID;
      this.getSNFDashboardCores(selectedTab.processStageID);
    }
  }

  addFolder(templateRef: TemplateRef<any>, name: string) {
    this.selectedTab = name;
    if (name === 'Census') {
      this.dialog.open(templateRef, {
        width: '40vw',
      });
    } else {
      // this.dialog.open(templateRef, {
      //   width: '70vw',
      //   height: 'auto',
      //   panelClass: 'custom-dialog-container'
      // });
    }

  }

  params: string = "";
  getassign: any;
  SendButtonDisabled: boolean = false;
  NormalContacts: any = [];
  SharedContacts: any = [];
  MatchingRole: any = [];

  signNow(token: any, doc: any, core: any) {
    this.params = decodeURIComponent(token);
    const decryptedTokenString = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
    let decryptedToken = JSON.parse(decryptedTokenString)
    let objModel = {
      "OfficeID": decryptedToken.OfficeID,
      "IsReadOnlyFromSentPage": false,
      "ProjectID": decryptedToken.FormID,
      "FormID": decryptedToken.FormID,
      "CoreID": Number(core.coreID),
      "CorePlaceholderID": doc.placeholderID,
      "DocumentHtmls": "",
      "participantJsonList": "",
      "documentFolderID": doc.documentFolderID,
      "Email": "",
      "DatabaseID": decryptedToken.DatabaseID,
      "OrganizationID": decryptedToken.OrganizationID,
      "UserID": decryptedToken.UserID,
      "userEmailFromWhereSignNowCame": sessionStorage.getItem('email')
    };
    let jsonStringToken = JSON.stringify(objModel);
    token = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonStringToken);
    token = encodeURIComponent(token);

    //1pdf 2 tabular 3 html{
    let url = '';
    if (doc.formType == 1)
      url = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + token + "&type=1";
    else if (doc.formType == 2)
      url = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + token + "&type=1";
    window.open(url, "_blank");
  }


  creatProject(document, core) {
    var ReqModel = {
      transactionID: Number(core.coreID),
      documentFolderID: document.documentFolderID,
      formID: document.formID,
      formType: FormAuditType.NormalForm,
      placeholderID: document.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
      taskID: document.taskID,
      projectID: document.projectID
    }
    this.loaderService.show();
    this.formsService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Project created successfully.', '', {
            timeOut: 3000,
          });
          this.getSNFDashboardCores(this.selectedprocessStageID);
        } else {
          this.getSNFDashboardCores(this.selectedprocessStageID);
          this.loaderService.hide();
        }
      } else {
        this.getSNFDashboardCores(this.selectedprocessStageID);
        this.loaderService.hide();
      }
    });
  }

  EditProject(document, core) {
    this.getassign = document;
    this.SendButtonDisabled = false;
    const dialogRef = this.dialog.open(CreateProjectsComponent, {
      data: {
        document: document,
        transactionID: core.coreID
      },
      // width: '70vw',
      // height: 'auto',
      panelClass: 'signatureModal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getSNFDashboardCores(this.selectedprocessStageID);
      }
    });

  }

  EditForm(document: any, core: any) {
    sessionStorage.setItem('projectID', document.projectID);
    sessionStorage.setItem('type', (ProjectTempType.Project).toString()); // 1 for Project and 2 for Template
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName("");
    let links = window.location.href.split(window.location.pathname)[0] + "/esignature/third"
    window.open(links, "_blank");
    sessionStorage.setItem('HeaderModuleName', 'Forms');
    this._dataSharingService.sendSelectedModuleName('Forms');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }



  AddRowImportant(core: any, templateRef: TemplateRef<any>) {
    this.deleteList = [];
    var id = core.coreID;
    this.deleteList.push(id);
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.currentImportantFavoriteElement = core;
  }

  DeleteImportant(core: any) {
    core.isImportant = false;
    this.toastr.info('Marked as unimportant successfully.', '', { timeOut: 3000 });
    var deleteList = [];
    var id = core.coreID;
    deleteList.push(id);

    var reqModel = {
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      coreID: deleteList,
      officeID: this.myOfficeID,
    }
    //this.loaderService.show();
    this.formsService.ImportantDeleteCoreTransaction(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
        //  this.loaderService.hide();
          // this.getPDPMCores(0, this.selectedListType);
        }
      } else {
       // this.loaderService.hide();
      }
    });
  }


  selectedImpColors(colors: any) {
    this.currentImportantFavoriteElement.isImportantColorCode = colors;
    this.currentImportantFavoriteElement.isImportant = true;
    this.toastr.success('Marked as important successfully.', '', { timeOut: 3000 });
    this.cdr.markForCheck();
    var reqModel = {
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      coreID: this.deleteList,
      officeID: this.myOfficeID,
      favouriteColorCode: colors,
    }
    //this.loaderService.show();
    this.formsService.ImportantCoreTransaction(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
         // this.loaderService.hide();
          this.closeColor();
          // this.getPDPMCores(0, this.selectedListType);
        }
      } else {
        this.closeColor();
       // this.loaderService.hide();
      }
    });
  }













  FillSelectForm(document: any, core: any) {
    var ReqModel = {
      transactionID: Number(core.coreID),
      documentFolderID: document.documentFolderID,
      taskID: document.taskID,
      formID: document.formID,
      projectID: document.projectID,
      formType: document.formType,
      placeholderID: document.placeholderID,
      fileID: 0,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.formsService.autoFillCoreDataintoProject(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Selected Document filled successfully.', '', {
            timeOut: 3000,
          });
          this.getSNFDashboardCores(this.selectedprocessStageID);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  OpenProfile(coreRecord) {
    var getCoreId: any = [];
    var TypeID: any = [];
    getCoreId = coreRecord.filter(x => x.fieldName == "Name");
    if (getCoreId.length > 0) {
      sessionStorage.setItem('transactionID', getCoreId[0].coreID);
    }
    TypeID = coreRecord.filter(x => x.fieldName == "Type");
    if (TypeID.length > 0) {
      sessionStorage.setItem('TypeID', TypeID[0].fieldValue.toString());
    }
    sessionStorage.setItem('moduleName', 'Core');
    window.open('/core/documents', '_blank');
  }

  openFrom: string = "";

  openTaskList(task: any, core: any) {
    const dialogRef = this.dialog.open(SNFTasklistComponent, {
      data: {
        taskListID: task.coreTask,
        transactionID: core.coreID
      },
      width: '70vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        // this.openFrom= "TaskList";
        if (result == "StatusUpdated") {
          this.getSNFDashboardCores(this.selectedprocessStageID);
        }
      }
    });
  }


  openDocumentDetail: boolean = false;
  selectedDocument: any;
  transactionID: number = 0;

  showDocumentDetails(data: any, core: any) {
    this.selectedDocument = data;
    this.transactionID = core.coreID;
    this.openDocumentDetail = true;
  }

  getClose(closeDetail: boolean) {
    this.openDocumentDetail = closeDetail;
  }

  @ViewChild('Input') InputFile: ElementRef;
  selectedFilePlaceHolder: string = '';
  selectedFolderId: string = '';
  selectedFile: string = '';
  formData: FormData;

  onFileSelectPlaceHolder(event, selectedFolder, document) {
    if (event.target.files.length > 0) {
      if (event.target.files[0].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        return;
      }
      this.UploadFileWithExistingPlaceHolder(document, event.target.files, selectedFolder);
    } else {
      this.selectedFile = '';
    }
  }

  UploadFileWithExistingPlaceHolder(document, uploadDocument, selectedFolder) {
    this.formData = new FormData();
    let files = uploadDocument;//this.uploadFormPlaceHolder.get('uploadDocument').value;
    if (files !== '' && files !== null) {
      var newfilename = files[0].name.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      let documentType = newfilename.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.toastr.warning('Please select document');
      return;
    }
    this.formData.append('TransactionID', document.coreID);
    this.formData.append('DocumentFolderID', selectedFolder.documentFolderID);
    this.formData.append('FormID', '0');
    this.formData.append('PlaceholderType', '1');
    this.formData.append('DocumentName', selectedFolder.placeholderName);
    this.formData.append('PlaceholderName', selectedFolder.placeholderName);
    this.formData.append('PlaceholderID', selectedFolder.placeholderID);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.loaderService.show();
    this.formsService.AddCoreItemForPlaceholder(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.selectedFile = '';
          this.getSNFDashboardCores(this.selectedprocessStageID);
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  DownloadSigleFile(filename: any, core: any) {
    var ReqModel = {
      transactionID: Number(core.coreID),
      placeholderID: filename.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.formsService.DownloadCoreDocument(ReqModel).subscribe((response) => {
      if (response != undefined && response.base64URL != null && response.base64URL != undefined) {
        const data = 'data:' + response.contentType + ';base64,' + response.base64URL;
        FileSaver.saveAs(data, response.name);
      } else {
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }

  FillPlaceholderForDocument(document, core: any) {
    return;
    var ReqModel = {
      placeholderID: document.placeholderID,
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.formsService.FillPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          var pdfData = this.responseHolder.data;
          var ProjectName = pdfData.documentName.split('.');
          sessionStorage.removeItem("ProjectName");
          sessionStorage.removeItem("projectID");
          sessionStorage.setItem('ProjectName', ProjectName[0]);
          sessionStorage.setItem('type', (ProjectTempType.Project).toString());
          sessionStorage.setItem('ImportTemplateShow', 'true');
          sessionStorage.setItem('MasterTemplatePDFForm', 'false');
          sessionStorage.setItem('MasterTemplateTabularForm', 'false');
          sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
          sessionStorage.setItem('MasterTemplateWebForm', 'false');
          this._dataSharingService.sendSelectedProjectName(ProjectName[0]);
          var ReqModel = {
            Document: pdfData,
            TransactionID: Number(this.transactionID),
            TransactionType: 1, //1 core, 2 Contact, 3 Company
            PlaceholderID: document.placeholderID
          }
          this._dataSharingService.sendFillPlaceholderDocumentForCore(ReqModel);
          //this.router.navigate(['/esignature/first']);
          window.open('/esignature/first', '_blank');
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  openUploadDocumentPopupForAI(task: any, core: any) {
    var getCoreId: any = [] = [];
    var name: string = "";
    getCoreId = core.fields.filter(x => x.fieldName == "Name");
    if (getCoreId.length > 0) {
      name = getCoreId[0].fieldValue;
    }
    const dialogRef = this.dialog.open(UploadAIDocuments, {
      data: {
        transactionID: core.coreID,
        Name: name
      },
      width: '30vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

      }
    });

  }

  getCloseDocumentViewer(closeDetail: boolean) {
    this.openDocumentViewers = closeDetail;
  }

  openPDFViewer(data, core) {
    this.openDocumentViewers = true;
    this.selectedDocument = data;
    this.transactionID = core.coreID;
  }

  startNewSignatureProject() {
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('type', ("1").toString());
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId', '0');
    sessionStorage.setItem('FolderOpenName', '');
    this._dataSharingService.sendSelectedProjectName("");
    sessionStorage.setItem('isSharedWithMeForm', 'false');
    //this.router.navigate(['/esignature/first']);
    window.open('/esignature/first', '_blank');
  }

  quickSignDocument() {

  }

  pageModelData = {
    pageIndex: 0,
    pageSize: 100,
    searchValue: '',
  };

  pageIndex: any;
  pageSize: any;
  inboxProjectsList: any[] = [];
  sentProjectsList: any[] = [];
  draftProjectsList: any[] = [];
  totalReadyToSign: number = 0;
  totalPending: number = 0;
  totalDrafts: number = 0;

  // ==== For Ready ====//
  getInboxProjects(pageData: any) {
    var ReqModel = {
      pageIndex: this.pageModelData.pageIndex,
      pageSize: this.pageModelData.pageSize,
      searchKey: this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formsService.getInboxProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.inboxProjectsList = response.data.sentOrInboxListModelList;
        // this.inboxProjectsList = this.inboxProjectsList.filter((m) => m.status == 0 || m.status==2);
        // this.inboxProjectsList.forEach(e => {
        //   e.signHref = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + e.signingToken
        // });
        if (this.inboxProjectsList.length > 0) {
          this.totalReadyToSign = response.data.totalcount;
        } else {
          this.totalReadyToSign = 0;
        }
      }
      else {
      }
    });
  }

  // ==== For Pending ====//
  getSentProjects(pageData: any) {
    var ReqModel = {
      pageIndex: this.pageModelData.pageIndex,
      pageSize: this.pageModelData.pageSize,
      searchKey: this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formsService.getSentProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.sentProjectsList = response.data.sentOrInboxListModelList;
        if (this.sentProjectsList.length > 0) {
          this.totalPending = response.data.totalcount;
        } else {
          this.totalPending = 0;
        }
      } else {
      }
    });
  }

  // ==== For Drafts ====//
  getDraftedProjects(pageData: any) {
    var ReqModel = {
      projectStatus: 1,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      searchKey: this.pageModelData.searchValue,
      pageIndex: pageData.pageIndex,
      pageSize: pageData.pageSize,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formsService.getDraftedProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.draftProjectsList = response.data.projects;
        if (this.draftProjectsList.length > 0) {
          this.totalDrafts = response.data.totalcount;
        } else {
          this.totalDrafts = 0;
        }
      } else {
      }
    });
  }

  OpenReadyToSignature(OpenFrom: string) {
    // return;
    const dialogRef = this.dialog.open(SignaturesDataShowComponent, {
      data: {
        openFrom: OpenFrom,
      },
      width: '50vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
      }
    });
  }

  favoritesCount = 0;

  quickLinks = [
    { title: 'Admission Forms', type: 'forms', icon: 'description', favorite: true },
    { title: 'MDS Assessment', type: 'forms', icon: 'assignment', favorite: true },
    { title: 'Care Plans', type: 'workflows', icon: 'favorite', favorite: false },
    { title: 'Medication Orders', type: 'tools', icon: 'medication', favorite: false },
    { title: 'Discharge Planning', type: 'workflows', icon: 'exit_to_app', favorite: false },
    { title: 'Census Reports', type: 'reports', icon: 'bar_chart', favorite: false },
    { title: 'Shift Reports', type: 'reports', icon: 'schedule', favorite: false },
    { title: 'Compliance Check', type: 'tools', icon: 'check_circle', favorite: false },
  ];

  getTagClass(type: string) {
    switch (type) {
      case 'forms': return 'chip-forms';
      case 'workflows': return 'chip-workflows';
      case 'tools': return 'chip-tools';
      case 'reports': return 'chip-reports';
      default: return '';
    }
  }

  //quickLinkAPIArray:any=[]=[];
  allQuickLinks: any[] = [];

  quickLinkAPIArray: any = {
    forms: [],
    urls: [],
    folders: [],
    tasklists: []
  };

  DashboardFavoriteItems() {
    const ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };

    this.loaderService.show();

    this.formsService.DashboardFavoriteItems(ReqModel).subscribe((response) => {
      this.loaderService.hide();

      if (response) {
        this.responseHolder = response;

        if (this.responseHolder.status === this.statusConstant.statusSuccess) {
          this.quickLinkAPIArray = this.responseHolder.data || {
            forms: [],
            urls: [],
            folders: [],
            tasklists: []
          };

          // build flattened array
          this.allQuickLinks = [
            ...(this.quickLinkAPIArray.forms?.map(f => ({ ...f, type: 'Form' })) || []),
            ...(this.quickLinkAPIArray.urls?.map(u => ({ ...u, type: 'Url' })) || []),
            ...(this.quickLinkAPIArray.folders?.map(fd => ({ ...fd, type: 'Folder' })) || []),
            ...(this.quickLinkAPIArray.tasklists?.map(t => ({ ...t, type: 'Task List' })) || [])
          ];

          // ✅ Move favorites on top
          this.allQuickLinks.sort((a, b) => {
            if (a.isFavorite === b.isFavorite) return 0;
            return a.isFavorite ? -1 : 1; // true first
          });

          // ✅ count favorites
          this.favoritesCount = this.allQuickLinks.filter(x => x.isFavorite).length;

          this.updateDisplayQuickLinks();
        } else {
          this.toastr.error('Error occurred.', '', { timeOut: 3000 });
        }
      }
    });
  }

  // DashboardFavoriteItems() {
  //   const ReqModel = {
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //     officeID: this.myOfficeID,
  //   };

  //   this.loaderService.show();

  //   this.formsService.DashboardFavoriteItems(ReqModel).subscribe((response) => {
  //     this.loaderService.hide();

  //     if (response) {
  //       this.responseHolder = response;

  //       if (this.responseHolder.status === this.statusConstant.statusSuccess) {
  //         this.quickLinkAPIArray = this.responseHolder.data || {
  //           forms: [],
  //           urls: [],
  //           folders: [],
  //           tasklists: []
  //         };

  //         // build flattened array
  //         this.allQuickLinks = [
  //           ...(this.quickLinkAPIArray.forms?.map(f => ({ ...f, type: 'Form' })) || []),
  //           ...(this.quickLinkAPIArray.urls?.map(u => ({ ...u, type: 'Url' })) || []),
  //           ...(this.quickLinkAPIArray.folders?.map(fd => ({ ...fd, type: 'Folder' })) || []),
  //           ...(this.quickLinkAPIArray.tasklists?.map(t => ({ ...t, type: 'Task List' })) || [])
  //         ];
  //         this.updateDisplayQuickLinks();
  //       } else {
  //         this.toastr.error('Error occurred.', '', { timeOut: 3000 });
  //       }
  //     }
  //   });
  // }

  displayQuickLinks: any = [] = [];

  // helper function
  updateDisplayQuickLinks() {
    this.displayQuickLinks = this.showAll
      ? this.allQuickLinks
      : this.allQuickLinks.slice(0, this.visibleCount);
  }

  openPopup(templateRef: TemplateRef<any>) {
    this.formIcon = "";
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'addThirdParty'
    });
  }

  closeSendTaskListURL() {
    this.name = "";
    this.spinner = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.selectCoreList = [];
    this.dialog.closeAll();
  }

  selectIcon() {
    const dialogRef = this.dialog.open(SelectFormIconComponent, {

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.formIcon = result.icon;
        // this.iconName = result.name;  
      }
    });
  }

  addDashboardQuicklink(addQuickLinkForm) {
    if (!(document.getElementById("urlname") as HTMLInputElement).value || !(document.getElementById("urlname") as HTMLInputElement).value || !this.formIcon) {
      this.toastr.warning('Please provide a Name, Link, and select an Icon before saving.', '', {
        timeOut: 3000,
      });
      return;
    }
    var ReqModel = {
      id: 0,
      name: (document.getElementById("urlname") as HTMLInputElement).value,
      favoriteType: 4, //form
      url: (document.getElementById("urllink") as HTMLInputElement).value,
      icon: this.formIcon,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      color: addQuickLinkForm.quickLink,
    };
    this.loaderService.show()
    this.formsService.AddDashboardFavoriteItem(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.close();
        this.formIcon = "";
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.DashboardFavoriteItems();
          this.toastr.success('Dashboard Quick Added successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.toastr.error('Error occurred.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  noteID: number = 0;
  savebuttonshow: boolean = false;
  addnotes: number = 0;
  color: string = "";
  close() {
    this.savebuttonshow = false;
    this.noteID = 0;
    this.selectedColor = "";
    this.addnotes = 0;
    //this.addNotesForm.reset();
    this.dialog.closeAll();
  }

  taskStatusColors = ['#8f8f8f', '#fdab3d', '#e2445c', '#00c875', '#db241c']
  taskPriorityColors = ['#8f8f8f', '#fdab3d', '#e2445c', '#00c875', '#db241c']

  getBackground(stat) {
    switch (stat) {
      case 1:
        return this.taskStatusColors[0];

      case 2:
        return this.taskStatusColors[1];

      case 3:
        return this.taskStatusColors[2];

      case 4:
        return this.taskStatusColors[3];

      case 5:
        return this.taskStatusColors[4];

      default:
        return "#000000"

    }

  }

  deleteQuickLink(link: any) {
    this.showHideQuickLink();
    this.RemoveDashboardFavoriteItem(link)
  }

  showHideQuickLink() {
    // Find all elements with the class 'showOnClick'
    const elements = document.querySelectorAll('.showOnClick');
    // Loop through each element
    elements.forEach(element => {
      // Check if the element has the class 'hideCrossBtn'
      if (element.classList.contains('hideCrossBtn')) {
        // If it has the class, remove it
        element.classList.remove('hideCrossBtn');
      } else {
        // If it doesn't have the class, add it
        element.classList.add('hideCrossBtn');
      }
    });
  }

  RemoveDashboardFavoriteItem(link: any) {
    var message = `Are you sure you want to delete record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var ReqModel = {
          FavoriteID: link.favouriteID,//this.selectedRecordDeleteArray,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
          officeID: this.myOfficeID,
        };
        this.formsService.RemoveDashboardFavoriteItem(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.DashboardFavoriteItems();
            this.toastr.success('Quick Link Deleted successfully.', '', {
              timeOut: 3000,
            });
          }
        });
      }
    });
  }


  openExternalLink(link: any): void {
    if (link) {
      // Check if the link already starts with 'http://' or 'https://'
      if (!link.startsWith('http://') && !link.startsWith('https://')) {
        // If not, prepend 'https://' to the link
        link = 'https://' + link;
      }
      // Open the link in a new tab
      window.open(link, '_blank', 'noopener,noreferrer');
    } else {
      console.error("Invalid link provided.");
    }
  }

  openFilemanagerFolder(link: any) {
    const encodedData = this.encodeData(link);
    this.router.navigate(['/filemanager'], { queryParams: { data: encodedData } });
  }

  encodeData(data: any): string {
    return btoa(JSON.stringify(data)); // Convert object to Base64 string
  }


  OpenFolderSendEmail(templateRef: TemplateRef<any>, taskTemplate: any) {
    this.taskTemplateAfterAddingCore = taskTemplate;
    this.checkedByDefaultEmail = true;
    this.checkedByDefaultCore = false;
    this.TaskListName = taskTemplate.templateName;
    this.name = "";
    this.emailid = "";
    this.addButtonShow = false;
    this.SendEmailList = [];

    this.showSearchCore = false;
    this.selectCoreList = [];

    this.AttachChecked = false;
    this.AssigneeChecked = true;
    this.NotifyChecked = false;
    this.SendEmailLater = false;

    this.taskTemplateID = taskTemplate.id;
    this.GetRelationByTaskTemplateID(this.taskTemplateID);
    if (taskTemplate.taskListFolderID > 0) {
      this.taskListFolderID = taskTemplate.taskListFolderID;
    } else {
      this.taskListFolderID = 0;
    }

    this.showTemplateDetailCheckingDuplicateEmail(taskTemplate.id);
    this.ButtonForFolder = false;
    this.ButtonForUploadImage = false;

    this.showEmail = false;
    this.showMobile = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.emailid = "";
    this.mobileNo = "";

    this.sendButton = false;

    this.dialog.open(templateRef, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      width: '700px',
      maxHeight: '700px',
    });
  }

  GetRelationByTaskTemplateID(TaskTemplateID: any) {
    var ReqModel = {
      TaskTemplateID: Number(TaskTemplateID),
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.formsService.GetRelationByTaskTemplateID(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          this.relationList = response.data;
        } else {
          this.relationList = [];
        }
      } else {
        this.relationList = [];
      }
    });
  }

  showTemplateDetailCheckingDuplicateEmail(templateID) {
    this.loaderService.show();
    this.currentTemplateId = templateID;
    let ReqModel = {
      "taskTemplateID": templateID,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": this.myOfficeID,
      "officeIDList": this.OfficeIDList,
      "databaseID": Number(this.databaseId),
    }
    this.taskService.getTaskTemplateEmailLog(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sendForSign = response.data;
        }
      }
    })

  }

  @ViewChild('SendTaskListURL') SendTaskListURL!: TemplateRef<any>;
  showAuthenticationType = true;

  openLink(link: any) {
    switch (link.type) {
      case 'Form':
        this.openProject(link);
        break;

      case 'Url':
        this.openExternalLink(link.url);
        break;

      case 'Folder':
        this.openFilemanagerFolder(link);
        break;

      case 'Task List':
        this.OpenFolderSendEmail(this.SendTaskListURL, link);
        break;

      default:
      // console.warn('Unknown link type:', link);
    }
  }

  openProject(form) {
    var ReqModel = {
      formFolderId: 0,
      formId: form.id,
      formName: form.name, //form.name,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
    };
    this.loaderService.show()
    this.formsService.UseFormsTemplateForProject(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          sessionStorage.setItem('projectID', response.data.projectID);
          sessionStorage.setItem('type', (1).toString());  // 1 for Project and 2 for Template         
          this.router.navigate(['/esignature/second']);
          sessionStorage.setItem('HeaderModuleName', 'Template');
          sessionStorage.setItem('isSharedWithMeForm', 'false');
          sessionStorage.setItem('MasterTemplatePDFForm', 'false');
          sessionStorage.setItem('MasterTemplateTabularForm', 'false');
          sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
          sessionStorage.setItem('MasterTemplateWebForm', 'false');
          this._dataSharingService.sendSelectedModuleName('Forms');
          this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
        } else {
          this.loaderService.hide();
        }
      }
    });

  }


  toggleShow() {
    this.showAll = !this.showAll;
    this.updateDisplayQuickLinks();
  }


  onNotASignerChange(event: Event, email: any) {
    let isTasklistCheckboxChecked = (event.target as HTMLInputElement).checked;
    this.selectCoreList.find(m => m.emailid == email.emailid).isNotASigner = isTasklistCheckboxChecked;
  }

  //************** */
  coreSelected(coreSelected: any) {
    var check = [];
    check = this.selectCoreList.filter(x => x.coreID == coreSelected.coreID);
    if (check.length > 0) {
      this.stateCtrl.setValue('');
      this.toastr.warning('Selected ' + this.orgModuleNameCore + ' is allready added.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (coreSelected.coreID == 0) {
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.addNewCore('Core');
      return;
    }
    this.selectedCoreEmailID = coreSelected.email;
    this.selectCoreList.push({
      name: coreSelected.name,
      emailid: coreSelected.email,
      img: coreSelected.imageUrl,
      coreID: coreSelected.coreID,
      shortName: coreSelected.shortName,
      isNotASigner: false,
      contactAttachWithCores: []
    });
    this.stateCtrl.setValue('');
    if (this.selectCoreList.length > 0) {
    }
    else {
    }
  }

  addNewCore(module, emailid = '') {
    this.mainModuleName = module;
    var menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var Module = menuModulesList.filter((x) => x.mainModuleName == module);
    var Modulename = Module[0].orgModuleName;
    this.Module = Modulename;
    this.showAddCore = !this.showAddCore;
    this.selectedCoreEmailID = emailid;
  }

  getCloseCore(message) {
    this.showAddCore = message;
  }

  showDetail: boolean = false;
  // mainModuleNameForDetails: string = "";

  editCore(data: any) {
    this.mainModuleNameForDetails = "Core";
    this.transactionID = data.coreID;
    this.showDetail = !this.showDetail;
    this.dialog.closeAll();
  }

  removeCore(email: any) {
    let removeIndex = this.selectCoreList.findIndex((itm) => itm.emailid === email);
    if (removeIndex !== -1) this.selectCoreList.splice(removeIndex, 1);
  }



  SendEmailForTaskListURL(SendEmailLater: boolean) {
    if (this.selectCoreList.length > 0) {
      var coreList = [];
      for (let i = 0; i < this.selectCoreList.length; i++) {
        if (this.selectCoreList[i].isNotASigner == false) {
          this.selectCoreList[i].contactAttachWithCores = [];
        }
        if (this.selectCoreList[i].isNotASigner == true) {
          if (this.selectCoreList[i].contactAttachWithCores.length == 0) {
            this.toastr.warning('Please add ' + this.orgModuleNameContact + '', '', {
              timeOut: 4000,
            });
            return;
          }
          if (this.selectCoreList[i].contactAttachWithCores.length > 0) {
            if (this.relationList.length > 0) {
              var checkRelation: number = 0;
              checkRelation = this.selectCoreList[i].contactAttachWithCores[0].TransctionalRoleID;
              if (checkRelation == 0) {
                this.toastr.warning('Please Select Relation', '', {
                  timeOut: 4000,
                });
                return;
              }
            }
          }
        }

        var objcore = {
          cType: 1,
          cid: this.selectCoreList[i].coreID,
          name: this.selectCoreList[i].name,
          emailMobile: this.selectCoreList[i].emailid,
          messageType: 0, //0-Core ,1-Email , 2-Mobile
          contactAttachWithCores: this.selectCoreList[i].contactAttachWithCores,
          isNotASigner: this.selectCoreList[i].isNotASigner != undefined ? this.selectCoreList[i].isNotASigner : false
        }
        coreList.push(objcore);
      }
    }
    var ReqModel1 = {
      taskListID: 0,
      taskListName: this.TaskListName,
      position: 0,
      folderID: this.taskListFolderID,
      taskTemplateID: this.taskTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      emailMessageTos: coreList,
      isChildDueDate: false,
      sendEmailLater: SendEmailLater,
      keepAssignee: this.AssigneeChecked,
    }
    this.loaderService.show();
    this.ButtonForFolder = false;
    this.spinner = true;
    this.selectCoreList = [];
    this.taskService.SendEmailForTaskListURL(ReqModel1).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Tasklist url is successfully added .', '', {
            timeOut: 3000,
          });
          this.name = "";
          this.mobileNo = "";
          this.addButtonShow = false;
          this.AddTaskListEmailResult = this.responseHolder.data;
          this.AddTaskListEmailResult.forEach(el => {
            el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
          });
          this.loaderService.hide();
          this.SendMobileList = [];
          this.selectCoreList = [];
          this.closeSendTaskListURL();
          this.RecallSendEmailForTaskListURL(ReqModel1, response.data.map(m => m.taskListID));
        } else {
          this.selectCoreList = [];
          this.loaderService.hide();
          this.toastr.error(this.responseHolder.message, '', {
            timeOut: 3000,
          });
        }
      } else {
        this.name = "";
        this.mobileNo = "";
        this.addButtonShow = false;
        this.SendMobileList = [];
        this.selectCoreList = [];
        this.loaderService.hide();
      }
    });
  }

  RecallSendEmailForTaskListURL(ReqModel, taskListIDs) {
    ReqModel.IsChildDueDate = true;
    ReqModel.ChildTaskListIDs = taskListIDs;
    this.taskService.SendEmailForTaskListURL(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Child Task List added in task template successfully.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.name = "";
        this.emailid = "";
        this.savebuttonshow = false;
        this.SendEmailList = [];
        this.loaderService.hide();
      }
    });
  }

  searchCore(val) {
    this.attachedToCoreList = [];
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.attachedToCoreList = response.data;
          this.attachedToCoreList.push({
            coreID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            shortName: '',
          });
        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }

  showOptions(event: MatCheckboxChange, data): void {
    if (data == "Attach") {
      this.AttachChecked = event.checked;
    }
    if (data == "Assignee") {
      this.AssigneeChecked = event.checked;
    }
    if (data == "Notify") {
      this.NotifyChecked = event.checked;
    }
    if (data == "SendEmailLater") {
      this.SendEmailLater = event.checked;
    }
  }

  searchContacts(val) {
    if (val.length >= 2) {
      this.attachedToContactList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchContact(val)
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }
  getsearchContact(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });
    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formsService.searchContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.attachedToContactList = response.data;
          this.attachedToContactList.push({
            contactID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            shortName: '',
          });
        } else {
          this.attachedToContactList = [];
        }
      }
    })
  }


  OnChnageRelation($event, email) {
    this.selectCoreList.find(m => m.coreID == email.coreID).contactAttachWithCores[0].TransctionalRoleID = $event.value;
  }

  removeContactWithCoreCore(core) {
    this.selectedCoreEmailID = core.emailid;
    this.selectCoreList.find(m => m.emailid == core.emailid).contactAttachWithCores = [];
    this.contactsSelectedList = [];
  }

  //====== For Add Contact  ================//
  contactSelectedNew(contactSelected: any, emailid) {
    var check = [];
    this.contactsSelectedList = [];
    if (this.selectCoreList.find(m => m.emailid == emailid).contactAttachWithCores.length > 0) {
      check = this.selectCoreList.find(m => m.emailid == emailid).contactAttachWithCores.filter(x => x.contactID == contactSelected.contactID);
      if (check.length > 0) {
        this.stateCtrl.setValue('');
        this.toastr.warning('Selected ' + this.orgModuleNameContact + ' is allready added.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    if (contactSelected.contactID == 0) {
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.addNewCore('Contact', emailid);
      return;
    }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = contactSelected.name.match(/\b(\w)/g).join('');

    var obj = {
      name: contactSelected.name,
      email: contactSelected.email,
      contactID: contactSelected.contactID,
      img: contactSelected.imageUrl,
      shortName: shortName,
      TransctionalRoleID: 0
    }
    this.contactsSelectedList.push(obj);
    this.selectCoreList.find(m => m.emailid == emailid).contactAttachWithCores = this.contactsSelectedList;
  }

  getselectedTransactionId(result) {
    if (result.FromModuleName == 'Core') {
      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      this.selectedCoreEmailID = result.email;
      this.selectCoreList.push({
        name: result.name,
        emailid: result.email,
        img: "",
        coreID: result.transactionId,
        shortName: shortName,
        isNotASigner: false,
        contactAttachWithCores: []
      });
      if (this.selectCoreList.length > 0) {
      }
      else {
      }
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate, this.taskTemplateAfterAddingCore);
    }
    else if (result.FromModuleName == 'Contact') {
      this.contactsSelectedList = [];
      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      this.contactsSelectedList.push({
        name: result.name,
        email: result.email,
        img: "",
        contactID: result.transactionId,
        shortName: shortName,
        TransctionalRoleID: 0
      });
      if (this.selectCoreList.find(m => m.emailid == this.selectedCoreEmailID)) {
        this.selectCoreList.find(m => m.emailid == this.selectedCoreEmailID).contactAttachWithCores = this.contactsSelectedList;
      }
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate, this.taskTemplateAfterAddingCore);
    }
    if (result == "Close") {
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate, this.taskTemplateAfterAddingCore);
    }
  }


  OpenFolderSendEmailAddingCore(templateRef: TemplateRef<any>, taskTemplate: any) {
    this.TaskListName = taskTemplate.templateName;
    this.name = "";
    this.emailid = "";
    this.addButtonShow = false;
    this.SendEmailList = [];

    this.AttachChecked = false;
    this.AssigneeChecked = true;
    this.NotifyChecked = false;
    this.SendEmailLater = false;

    this.searchName = "";
    this.checkedByDefaultEmail = false;
    this.checkedByDefaultCore = true;
    this.showSearchCore = true;
    this.attachedToCoreList = [];

    this.taskTemplateID = taskTemplate.id;
    if (taskTemplate.taskListFolderID > 0) {
      this.taskListFolderID = taskTemplate.taskListFolderID;
    } else {
      this.taskListFolderID = 0;
    }

    this.showTemplateDetailCheckingDuplicateEmail(taskTemplate.id);
    this.ButtonForFolder = false;
    this.ButtonForUploadImage = false;

    this.showEmail = false;
    this.showMobile = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.emailid = "";
    this.mobileNo = "";
    this.sendButton = false;
    this.stateCtrl.setValue('');
    this.dialog.open(templateRef);

  }

  getCloseContacts(message) {
    this.showAddContact = message;
  }

  getUpdatedRecord(result) {
    if (result.FromModuleName == 'Core') {
      if (this.selectCoreList.length > 0) {
        this.selectCoreList.find((item) => item.coreID == result.transactionId).name = result.name;
        this.selectCoreList.find((item) => item.coreID == result.transactionId).emailid = result.email;
        this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate, this.taskTemplateAfterAddingCore);
      }
    }
  }

  getCloseDetails(message) {
    this.showDetail = false;
  }


  AddRowFavorite(data: any, isFavorite: boolean) {
    const ReqModel = {
      favoriteID: data.favouriteID,
      isFavorite: isFavorite,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    };
    this.formsService.addFavoriteItemForQuickLink(ReqModel).subscribe((response) => {
      if (response) {
        this.responseHolder = response;
        if (this.responseHolder.status === this.statusConstant.statusSuccess) {
          this.DashboardFavoriteItems();
        }
      }
    });
  }

  mainModuleNameForDetails: string = "Core";
  vieworUpdate: string = "";
  openFor: string = "";


  OpenDetails(core: any, open: any) {
    this.openFor = open;
    this.transactionID = Number(core.coreID);
    this.showDetail = true;
  }

  closeColor() {
    this.dialog.closeAll();
  }

  selectedColors(colors: any) {
    var reqModel = {
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      coreID: this.deleteList,
      officeID: this.myOfficeID,
      favouriteColorCode: colors,
    }
    this.loaderService.show();
    this.formsService.FavoriteCoreTransaction(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.closeColor();
          this.getSNFDashboardCores(this.selectedprocessStageID);
        }
      } else {
        this.loaderService.hide();
        this.closeColor();
      }
    });
  }

  deleteList:any=[];
  selectcoreIdForFav:number=0;

   AddRowFavorites(core:any,templateRef: TemplateRef<any>) {
      this.deleteList=[];
      var id = core.coreID;
      this.selectcoreIdForFav= core.coreID;
      this.deleteList.push(id);
      this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  FavoriteSelectedRecordForDeleteCore(core: any) {
    var deleteList = [];
    var id = core.coreID;
    deleteList.push(id);

      var reqModel={
        userID : this.currentUser.UID,
        databaseID : Number(this.databaseId),
        organizationID : Number(this.organizationId),
        coreID : deleteList,
        officeID : this.myOfficeID,
      }   
       const resident = this.adtTrackingAdmission.find(r => r.core?.coreID === core.coreID);
        if (resident && resident.core) {
          resident.core.favouriteColorCode = "";
          resident.core.isFavorite = false;
         }  
     // this.loaderService.show();
       this.formsService.FavoriteDeleteCoreTransaction(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          //  this.loaderService.hide();
          //  this.getSNFDashboardCores(this.selectedprocessStageID);
          }
        } else {
         // this.loaderService.hide();
        }
     
    });
  }




}
